import { getField, updateField } from 'vuex-map-fields';
import moment from 'moment';
import apiAxios from '../../services/apiAxios';
import helpers from '../../mixins/helpers';

const state = {
    cajasRegistros: [],
    /* Paginacion */
    paginaActual: 1,
    registrosPorPagina: 10,
    totalRegistros: 0,
    totalPaginas: 0,
    fechaAperturaDesde: moment(new Date()).add(-30, 'days').format('YYYY-MM-DD'),
    fechaAperturaHasta: moment(new Date()).format('YYYY-MM-DD'),
    incluirAbiertas: true,

    cajasRegistrosSelect: [],
    cajasRegistrosSelectList: []
};

const mutations = {
    updateField,

    'INICIALIZAR_OPCIONES'(state) {
        state.cajasRegistros = [];
        /* Opciones de filtro y paginacion */
        state.paginaActual = 1;
        state.registrosPorPagina = 10;
        state.totalRegistros = 0;
        state.totalPaginas = 0;

        state.fechaAperturaDesde = moment(new Date()).add(-30, 'days').format('YYYY-MM-DD');
        state.fechaAperturaHasta = moment(new Date()).format('YYYY-MM-DD');
        state.incluirAbiertas = true;
    },

    'INICIALIZAR_CAJAS_REGISTROS' (state) {
        state.cajasRegistros = [];
    },
    'SET_CAJAS_REGISTROS' (state, cajasRegistros) {
        state.cajasRegistros = cajasRegistros
            .map(cajaRegistro => ({...cajaRegistro, cerrada: (moment(cajaRegistro.fechaCierre).format('YYYY-MM-DD') == '1900-01-01' ? false: true) })  ) ;
    },
    'SET_PAGINATION'(state, params) {
        state.paginaActual = params.paginaActual;
        state.registrosPorPagina = params.registrosPorPagina;
        state.totalRegistros = params.totalRegistros;
        state.totalPaginas = params.totalPaginas;
    },

    'INICIALIZAR_CAJAS_REGISTROS_SELECT'(state) {
        state.cajasRegistrosSelect = [];
        state.cajasRegistrosSelectList = [];
    },
    'SET_CAJAS_REGISTROS_SELECT'(state, params) {
        state.cajasRegistrosSelect = params.cajasRegistrosSelect;
        state.cajasRegistrosSelectList = params.cajasRegistrosSelectList;
    },
};

const getters = {
    getField,

    cajasRegistrosSelect (state) {
        return state.cajasRegistrosSelect;
    },
    cajasRegistrosSelectList (state) {
        return state.cajasRegistrosSelectList;
    },
};

const actions = {
    inicializarOpciones ( { commit } ) {
        commit('INICIALIZAR_OPCIONES');
    },
        
    getCajasRegistros ( { commit, state } ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_CAJAS_REGISTROS');

            let queryString = '?pageSize=' + state.registrosPorPagina
                + '&pageNumber=' + state.paginaActual
                + '&fechaAperturaDesde='+ moment(state.fechaAperturaDesde).format('YYYY-MM-DD')
                + '&fechaAperturaHasta='+ moment(state.fechaAperturaHasta).format('YYYY-MM-DD');

            if ((/true/i).test(state.incluirAbiertas)) {
                queryString += '&incluirAbiertas= true';
            } else {
                queryString += '&incluirAbiertas= false';
            }
                    
            apiAxios.get('cajas' + queryString)
                .then(res => {
                    if (res.headers.pagination){
                        const pagination= JSON.parse(res.headers.pagination)
                        var params = {
                            paginaActual: pagination.currentPage,
                            registrosPorPagina: pagination.itemsPerPage,
                            totalRegistros: pagination.totalItems,
                            totalPaginas: pagination.totalPages,
                        }    
                        commit('SET_PAGINATION', params);
                    }
                    commit('SET_CAJAS_REGISTROS', res.data);

                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },

    getCajasRegistrosSelect: ({commit}) => {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_CAJAS_REGISTROS_SELECT');

            apiAxios.get('cajas/abiertas')
                .then(res => {
                    let list = [];
                    for(let key in res.data) {
                        const caja = res.data[key]
                        list.push(caja.nombre.trim())
                    }
                    let params = {
                        cajasRegistrosSelect: res.data,
                        cajasRegistrosSelectList: list
                    }
                    
                    commit('SET_CAJAS_REGISTROS_SELECT', params);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    abrirCaja ( {}, usuarioId ) {
        return new Promise((resolve, reject) => {
            apiAxios.post("cajas/abrir/" + usuarioId)
                .then(() => resolve())
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    cerrarCaja ( {}, params ) {
        return new Promise((resolve, reject) => {
            apiAxios.post("cajas/cerrar", params)
                .then(() => resolve())
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    ajusteCaja ( {}, params ) {
        return new Promise((resolve, reject) => {
            apiAxios.post('cajasmovimientos/ajuste', params)
                .then(() => resolve())
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}